<template>
  <v-container class="py-7">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">{{ pageTitle }}</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn type="button" elevation="0" color="primary" dark @click="save" :loading="loading">Salvar</v-btn>
            <v-btn type="button" elevation="0" color="primary" outlined to="/tenants">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="validForm">
      <v-row>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>Perfil da instituição</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field dense label="Nome" v-model="data.name" :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field dense label="Código" v-model="data.code" :disabled="!isNew" :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field dense label="Slug" v-model="data.slug" :disabled="!isNew" :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field dense label="Razão social" v-model="data.legal_name" outlined hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field dense label="Documento" v-model="data.document" outlined hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select dense label="Status" v-model="data.status" :items="statusItems" item-text="name" item-value="id" outlined hide-details="auto"></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-4">
            <v-card-title>Admin inicial</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field dense label="Nome" v-model="data.admin_name" :disabled="!isNew" outlined hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field dense label="E-mail" v-model="data.admin_email" :disabled="!isNew" outlined hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card>
            <v-card-title>White-label</v-card-title>
            <v-card-text>
              <v-text-field dense label="Nome do app" v-model="branding.app_name" outlined hide-details="auto" class="mb-3"></v-text-field>
              <v-text-field dense label="URL do logo" v-model="branding.logo_url" outlined hide-details="auto" class="mb-3"></v-text-field>
              <v-text-field dense label="Cor primária" v-model="branding.primary_color" outlined hide-details="auto" class="mb-3"></v-text-field>
              <v-text-field dense label="Domínio" v-model="branding.domain" outlined hide-details="auto"></v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mt-4">
            <v-card-title>Funcionalidades</v-card-title>
            <v-card-text>
              <v-switch v-model="features.facial_access" label="Controle facial" hide-details></v-switch>
              <v-switch v-model="features.school_transport" label="Transporte escolar" hide-details></v-switch>
              <v-switch v-model="features.financial_module" label="Financeiro" hide-details></v-switch>
              <v-switch v-model="features.pedagogical_module" label="Pedagógico" hide-details></v-switch>
              <v-switch v-model="features.student_entry_simulator" label="Simulador de acesso" hide-details></v-switch>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "TenantDetails",

  data: () => ({
    loading: false,
    validForm: true,
    data: {
      status: "active",
    },
    branding: {
      app_name: "",
      logo_url: "",
      primary_color: "#172554",
      domain: "",
    },
    features: {
      facial_access: true,
      school_transport: true,
      financial_module: false,
      pedagogical_module: true,
      student_entry_simulator: true,
    },
    statusItems: [
      { id: "active", name: "Ativo" },
      { id: "paused", name: "Pausado" },
    ],
  }),

  computed: {
    isNew() {
      return this.$route.params.id === "novo";
    },

    pageTitle() {
      return this.isNew ? "Novo tenant" : this.data.name || "Detalhes do tenant";
    },

    breadcrumbItems() {
      return [
        { text: "Homepage", disabled: false, to: "/home", exact: true },
        { text: "Tenants", disabled: false, to: "/tenants", exact: true },
        { text: this.isNew ? "Incluir tenant" : "Detalhes do tenant", disabled: true, exact: true },
      ];
    },
  },

  created() {
    this.load();
  },

  methods: {
    async load() {
      if (this.isNew) return;

      try {
        const result = await axios.get(`/api/v1/tenants/${this.$route.params.id}`);
        this.data = result.data.content;
        this.branding = this.parseJson(this.data.branding_json, this.branding);
        this.features = this.parseJson(this.data.features_json, this.features);
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
      }
    },

    parseJson(value, fallback) {
      if (!value) return { ...fallback };
      if (typeof value === "object") return { ...fallback, ...value };
      try {
        return { ...fallback, ...JSON.parse(value) };
      } catch (error) {
        return { ...fallback };
      }
    },

    buildPayload() {
      return {
        ...this.data,
        branding: this.branding,
        features: this.features,
        settings: {
          access: {
            requires_exit_authorization: true,
            sync_students_to_all_devices: false,
          },
        },
      };
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        const payload = this.buildPayload();

        if (this.isNew) {
          const result = await axios.post("/api/v1/tenants", payload);
          const password = result.data.content.temporary_password;
          this.$dialog.notify.info(password ? `Tenant criado. Senha inicial: ${password}` : "Tenant criado com sucesso.", { position: "top-right", timeout: 7000 });
        } else {
          await axios.patch(`/api/v1/tenants/${this.$route.params.id}`, payload);
          this.$dialog.notify.info("Tenant atualizado com sucesso.", { position: "top-right", timeout: 2000 });
        }

        this.$router.push("/tenants");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
